import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    documenti: [],
    singleDocumenti: {},
    isLoading: false,
    error: null,
    TipologiaDocumento: [],
    intervento:[],
    enumsLoading: {
      TipologiaDocumento: false,
      intervento : false
    },
    enumsError: {
      TipologiaDocumento: null,
      intervento : null

    }
}
const documentiSlice = createSlice({
    name: "documentiData",
    initialState,
    reducers: {
      setDocumenti: (state, action) => {
        state.documenti = action.payload;
        console.log("setProdotti - New prodotti:", state.mezzi);
      },
      addDocumenti: (state, action) => {
        state.documenti.push(action.payload);
      },
      addDocumentiId: (state, action) => {
        state.singleDocumenti = action.payload;
      },
      updateDocumenti: (state, action) => {
        const index = state.documenti.findIndex(
          (item) => item.id === action.payload.id
        );
        if (index !== -1) {
          state.documenti[index] = action.payload;
        }
      },
      setdeleteDocumenti: (state, action) => {
        state.documenti = state.documenti.filter(
          (item) => item.id !== action.payload
        );
      },
      apiRequestStart: (state) => {
        state.isLoading = true;
        state.error = null;
      },
      apiRequestSuccess: (state) => {
        state.isLoading = false;
      },
      apiRequestFailure: (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      },
      setTipologiaDocumento: (state, action) => {
        state.TipologiaDocumento = action.payload;
      },
      setIntervento: (state, action) => {
        state.intervento = action.payload;
      },
      enumRequestStart: (state, action) => {
        state.enumsLoading[action.payload] = true;
        state.enumsError[action.payload] = null;
      },
      enumRequestSuccess: (state, action) => {
        state.enumsLoading[action.payload] = false;
      },
      enumRequestFailure: (state, action) => {
        const { enumType, error } = action.payload;
        state.enumsLoading[enumType] = false;
        state.enumsError[enumType] = error;
      }
    },
  });
  export const {
    setDocumenti,
    addDocumenti,
    addDocumentiId,
    updateDocumenti,
    setdeleteDocumenti,
    apiRequestStart,
    apiRequestSuccess,
    apiRequestFailure,
    enumRequestFailure,
    enumRequestStart,
    enumRequestSuccess,
    setIntervento,
    setTipologiaDocumento
    } = documentiSlice.actions;
  // Fix the selectors to consistently use prodottoData
  // Fix the selectors to consistently use the same state path
  export const selectDocumenti = (state) => state.documenti?.documenti;
  export const selectSingleDocumenti = (state) => state.documenti?.singleDocumenti;
  export const selectIsLoading = (state) => state.documenti?.isLoading;
  export const selectError = (state) => state.documenti?.error;
  export const selectTipologiaDocumento = (state) => state.documenti?.TipologiaDocumento;
  export const selectIntervento = (state) => state.documenti?.intervento;

  export default documentiSlice.reducer;